import React from 'react';

import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Unstable_Grid2';

import { ITEM_WIDTH, getNbItemsPerRow } from '../../helpers/helpers';
import { IndicatorFilterT } from '../../../helpers/types';

type FilterSelectModalProps<T extends string> = {
    filter: IndicatorFilterT<T>[];
    options: IndicatorFilterT<T>[];
    setFilter: (arg: IndicatorFilterT<T>[]) => void;
    title: string;
};

const FilterSelectModal = <T extends string>({
    filter,
    options,
    setFilter,
    title,
}: FilterSelectModalProps<T>): JSX.Element => {
    const nbItemsPerRow = getNbItemsPerRow(options.length);

    const addFilterOptionToSelection = (fltr: IndicatorFilterT<T>) =>
        setFilter([...filter, fltr]);
    const removeFilterOptionFromSelection = (fltr: IndicatorFilterT<T>) =>
        setFilter([
            ...filter.filter(
                (selectedValue) => selectedValue.value !== fltr.value,
            ),
        ]);

    const handleCheck =
        (filteringOption: IndicatorFilterT<T>) =>
        (event: React.ChangeEvent<HTMLInputElement>) =>
            event.target.checked
                ? addFilterOptionToSelection(filteringOption)
                : removeFilterOptionFromSelection(filteringOption);

    const filterValues = filter.map((fltr) => fltr.value);

    return (
        <FormControl sx={{ m: 2 }} variant="standard">
            <Typography color="primary" sx={{ mb: 2 }} variant="body1Bold">
                {title}
            </Typography>
            <FormGroup>
                <Grid
                    container
                    spacing={1}
                    sx={{ width: `${ITEM_WIDTH * nbItemsPerRow}px` }}
                >
                    {options.map((option) => (
                        <Grid
                            key={option.value}
                            xs={12 / nbItemsPerRow}
                            sx={{ width: `${ITEM_WIDTH}px` }}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={filterValues.includes(
                                            option.value,
                                        )}
                                        onChange={handleCheck(option)}
                                        name={option.name}
                                    />
                                }
                                label={
                                    <Typography title={option.name} noWrap>
                                        {option.name}
                                    </Typography>
                                }
                                sx={{ display: 'flex' }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </FormGroup>
        </FormControl>
    );
};

export default FilterSelectModal;
